<template lang="pug">
#roam.comAll(v-dragDiv, v-show='!actionData.isMini')
  .title.moveDragDiv
    span {{ actionData.cnName }}
    i.el-icon-minus.minibtn(title='最小化', @click='miniCom')
    i.el-icon-close(title='关闭', @click='closeAdd')
  .btn-list
    el-button(type='primary', size='mini', @click='addFrame', :disabled='isRoaming') 添加关键帧
    el-button(type='primary', size='mini', @click='startRoaming', :disabled='frameList.length <= 0 || isRoaming') 开始漫游
    el-button(type='danger', size='mini', @click='stopRoaming', :disabled='!isRoaming') 停止漫游
  draggable.nav(v-model='frameList', :options='{ animation: 200 }')
    transition-group
      .frame(v-for='(item, index) in frameList', :key='index')
        .dwgInfo
          el-image(:src='item.dataUrl', :preview-src-list='[item.dataUrl]', alt='快照')
          .oper
            .icon-list
              i.el-icon-location-outline(title='定位', @click='setViewPortById(item.uuid)')
              i.el-icon-copy-document(title='复制', @click='copyFrame(item.uuid)')
              i.el-icon-delete(title='删除', @click='removeFrame(item.uuid)')
            .frame-time
              span 上一帧到此帧用时:
              el-input-number(v-model='item.duration', controls-position='right', size='mini', :min='0')
              span 秒
</template>

<script>
import draggable from 'vuedraggable';
import mongeApiMlib from '@/CommonDP/mongeView/mongeApiMlib';
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    draggable
  },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      frameList: [],
      isRoaming: false
    };
  },
  computed: {
    disableAddFrame() {
      return this.frameList.length === 0 && this.isRoaming;
    }
  },
  methods: {
    addFrame() {
      mongeApiMlib.addFrame({
        callback: obj => {
          obj.uuid = uuidv4();
          this.frameList.push(obj);
        }
      });
    },
    // 开始漫游
    startRoaming() {
      this.isRoaming = true;
      const list = [];
      this.frameList.forEach(element => {
        const viewport = element.viewport;
        const duration = element.duration * 1000;
        list.push({
          position: viewport.position,
          target: viewport.target,
          duration
        });
      });
      mongeApiMlib.startRoaming(list, {
        callback: () => {
          this.isRoaming = false;
        }
      });
    },
    // 停止漫游
    stopRoaming() {
      this.isRoaming = false;
      mongeApiMlib.stopRoaming();
    },
    // 定位
    setViewPortById(id) {
      const viewport = this.frameList.find(e => e.uuid === id).viewport;
      mongeApiMlib.setViewport(viewport);
    },
    // 复制
    copyFrame(id) {
      const index = this.frameList.findIndex(f => f.uuid === id);
      if (index > -1) {
        const frame = JSON.parse(JSON.stringify(this.frameList[index]));
        frame.uuid = uuidv4();
        this.frameList.splice(index + 1, 0, frame);
      }
    },
    // 删除
    removeFrame(id) {
      this.frameList = this.frameList.filter(e => e.uuid !== id);
    },
    miniCom() {
      this.$emit('closeCom', 'roaming', true);
    },
    closeAdd() {
      this.$emit('closeCom', 'roaming', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss"></style>
<style lang="scss" scoped>
#roam {
  position: fixed;
  top: 65px;
  left: auto;
  right: 100px;
  width: 440px;
  height: calc(100% - 190px);
  max-height: 770px;
}
.btn-list {
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.nav {
  padding: 0 10px;
  height: calc(100% - 90px);
  overflow-y: auto;
}
.dwgInfo {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  display: flex;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 10px;
  .el-image {
    width: 120px;
    height: 90px;
  }
  .oper {
    width: calc(100% - 120px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .icon-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 30px;
    padding-right: 10px;
    i {
      font-size: 20px;
      margin-right: 7px;
      cursor: pointer;
    }
  }
  .frame-time {
    margin-bottom: 10px;
    padding-left: 10px;
  }
}
</style>
